export function getTkv2SubjectQueryKey(orderID: string): string[] {
  return ['order', orderID, 'subject'];
}
